import axiosInstance from '@/api/http';
import { IResponse } from '@/api/IResponse';
import LoginModel from '@/models/login/LoginModel';
import SetPasswordModel from '@/models/login/setPasswordModel';

export default class LoginService {
  /**
   * @description: 用户登录
   * @params {LoginModel} params
   * @return {Promise}
   */
  static login = (params: LoginModel): Promise<IResponse> => axiosInstance.post('login', params).then((res) => res.data);

  /**
   * @description: 初次登录设置的密码
   * @userId UserInfo的Id
   * @return {Promise}
   */
   static setPassword = (params: SetPasswordModel): Promise<IResponse> => axiosInstance.post('login/setPassword', params).then((res) => res.data);
}
